/* V2.28.5. Compatible carrier choices survive variant navigation; transaction ownership is unchanged. */
(function () {
  'use strict';
  if (window.MekhannPdpCarrier) return;
  var ROOT = '[data-mekhann-pdp-carrier]';
  var GROUP_PROPERTY = '_mekhann_fitting_group';
  var instances = [];

  function error(text, validation) { var problem = new Error(text); problem.description = text; if (validation) problem.mekhannCarrierValidation = validation; return problem; }
  function positive(value) { return Number.isSafeInteger(Number(value)) && Number(value) > 0; }
  function groups() { return window.theme && window.theme.mekhannCartGroups; }
  function service() {
    var engine = window.MekhannCarrierPilotV2193;
    return engine && typeof engine.pdpReadCart === 'function' && typeof engine.pdpSetFitting === 'function' ? engine : null;
  }
  function readyService() {
    if (service()) return Promise.resolve(service());
    return new Promise(function (resolve, reject) {
      var timer;
      function clean() { clearTimeout(timer); document.removeEventListener('mekhann:carrier:ready', check); }
      function check() { if (service()) { clean(); resolve(service()); } }
      document.addEventListener('mekhann:carrier:ready', check);
      timer = setTimeout(function () { clean(); reject(error('Fitting options could not be loaded. Please refresh this page.')); }, 8000);
      check();
    });
  }
  function options(value) {
    if (!Array.isArray(value)) return [];
    return value.filter(function (entry) {
      return entry && positive(entry.id) && (entry.fitting === 'uk_eu' || entry.fitting === 'us');
    }).map(function (entry) {
      return { id: Number(entry.id), label: String(entry.label || ''), available: entry.available === true,
        recommended: entry.recommended === true, fitting: entry.fitting };
    });
  }
  function newGroup() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
    if (window.crypto && typeof window.crypto.getRandomValues === 'function') {
      return Array.prototype.map.call(window.crypto.getRandomValues(new Uint32Array(4)), function (part) { return part.toString(16); }).join('-');
    }
    return Date.now().toString(36) + '-' + Math.random().toString(36).slice(2) + '-' + Math.random().toString(36).slice(2);
  }
  function readEdit() {
    var query = new URL(window.location.href).searchParams;
    if (!query.has('mekhann_fitting')) return null;
    try {
      var descriptor = JSON.parse(query.get('mekhann_fitting'));
      if (!descriptor || !positive(descriptor.variantId) || !Array.isArray(descriptor.properties) ||
        descriptor.parentKey || !descriptor.properties.every(function (pair) { return Array.isArray(pair) && pair.length === 2 && typeof pair[0] === 'string'; })) throw new Error();
      return { descriptor: descriptor, valid: true };
    } catch (ignore) { return { descriptor: null, valid: false }; }
  }

  // The AjaxProduct purchase owner and the separate Apply action share one
  // browser-wide guard. The cart engine still owns server mutation serialisation.
  var purchaseBusy = false;
  var applyingController = null;
  function syncControls(nativeButton) {
    instances.forEach(function (controller) {
      if (controller.destroyed) return;
      if (nativeButton && controller.purchaseButton === nativeButton && controller.applyPurchaseLock) {
        // Called after the theme's native variant availability update. Preserve
        // that newest state rather than restoring the pre-Apply size's state.
        controller.applyPurchaseLock.disabled = Boolean(nativeButton.disabled);
      }
      controller.renderBusy();
    });
  }
  function setPurchaseBusy(busy) {
    purchaseBusy = Boolean(busy);
    if (purchaseBusy) instances.forEach(function (controller) { controller.choiceRevision += 1; });
    syncControls();
  }

  function Controller(root, form) {
    this.root = root;
    this.form = form;
    this.section = root.closest('[data-section-type="product"]') || root.parentElement;
    this.productId = Number(root.dataset.carrierProductId);
    this.variantId = Number(root.dataset.carrierVariantId);
    this.variants = {};
    this.rememberedChoices = {};
    this.fitting = 'none';
    this.carrierId = 0;
    this.parentGroupId = '';
    this.edit = this.section.matches('.product-section[data-history="true"]') ? readEdit() : null;
    this.editVariantId = this.edit && this.edit.descriptor ? Number(this.edit.descriptor.variantId) : this.variantId;
    this.editReady = false;
    this.editError = '';
    this.confirmedCarrierId = null;
    this.applyError = '';
    this.applyErrorVariantId = 0;
    this.applyNeedsRecovery = false;
    this.hasApplied = false;
    this.applyPurchaseLock = null;
    this.purchaseButton = form.querySelector('[data-add-to-cart], .add-to-cart');
    this.explicitChoiceRequired = false;
    this.choiceRevision = 0;
    this.applying = false;
    this.destroyed = false;
    this.status = root.querySelector('[data-carrier-status]');
    this.select = root.querySelector('[data-carrier-select]');
    this.editContext = root.querySelector('[data-carrier-edit-context]');
    this.applyButton = root.querySelector('[data-carrier-apply]');
    if (!this.select || !this.status || !this.editContext || !this.applyButton) throw error('Please refresh the page to load the carrier choices.');
    var data = JSON.parse(root.querySelector('[data-carrier-options]').textContent);
    var self = this;
    (data.variants || []).forEach(function (variant) {
      if (positive(variant.id)) self.variants[Number(variant.id)] = { available: variant.available === true, options: options(variant.options) };
    });
    var selected = form.querySelector('[data-product-select]');
    if (selected && positive(selected.value)) this.variantId = Number(selected.value);
    this.boundChange = this.onChange.bind(this);
    this.boundVariant = this.onVariant.bind(this);
    this.boundApply = function (event) { event.preventDefault(); self.applyExisting().catch(function () {}); };
    root.addEventListener('change', this.boundChange);
    this.applyButton.addEventListener('click', this.boundApply);
    this.section.addEventListener('variantChange', this.boundVariant);
    root.__mekhannCarrierController = this;
    form.__mekhannPdpCarrier = this;
    this.render();
    if (this.edit) this.loadEdit();
  }

  Controller.prototype.currentOptions = function () {
    var variant = this.variants[this.variantId];
    return variant ? variant.options : [];
  };
  Controller.prototype.say = function (text, quiet) {
    if (this.destroyed) return;
    this.status.setAttribute('data-carrier-status-kind', quiet ? 'notice' : 'action');
    this.status.textContent = text || '';
  };
  Controller.prototype.currentIssue = function () {
    if (this.edit && (!this.edit.valid || this.editMatches()) && this.editError) return this.editError;
    return this.variantId === this.applyErrorVariantId ? this.applyError : '';
  };
  Controller.prototype.choiceChanged = function () {
    return this.confirmedCarrierId == null || this.carrierId !== this.confirmedCarrierId;
  };
  Controller.prototype.capturePurchaseState = function () {
    var button = this.purchaseButton;
    if (!button) return;
    this.applyPurchaseLock = { disabled: Boolean(button.disabled), ariaDisabled: button.getAttribute('aria-disabled') };
  };
  Controller.prototype.syncPurchaseLock = function () {
    var button = this.purchaseButton;
    if (!button) return;
    if (applyingController) {
      if (!this.applyPurchaseLock) this.capturePurchaseState();
      button.setAttribute('data-mekhann-carrier-apply-busy', 'true');
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
      // The theme owns the primary button's loading animation. Apply owns only
      // this temporary availability lock and never changes its purchase label.
    } else if (this.applyPurchaseLock) {
      var state = this.applyPurchaseLock;
      button.disabled = state.disabled;
      if (state.ariaDisabled == null) button.removeAttribute('aria-disabled');
      else button.setAttribute('aria-disabled', state.ariaDisabled);
      button.removeAttribute('data-mekhann-carrier-apply-busy');
      this.applyPurchaseLock = null;
    }
  };
  Controller.prototype.option = function (id) {
    return this.currentOptions().find(function (entry) { return entry.id === Number(id); });
  };
  Controller.prototype.rememberChoice = function (explicit) {
    var chosen = this.option(this.carrierId);
    if (!positive(this.variantId) || this.explicitChoiceRequired || (!this.carrierId && !explicit) ||
        this.fitting !== 'none' && (!chosen || !chosen.available || chosen.fitting !== this.fitting)) return;
    this.rememberedChoices[this.variantId] = { carrierId: this.carrierId, fitting: this.fitting };
  };
  Controller.prototype.editMatches = function () {
    return Boolean(this.edit && this.edit.valid && this.variantId === this.editVariantId);
  };
  Controller.prototype.renderBusy = function () {
    this.select.disabled = purchaseBusy || Boolean(applyingController);
    this.applyButton.disabled = purchaseBusy || Boolean(applyingController) || !this.editMatches() || !this.editReady || this.explicitChoiceRequired || (!this.choiceChanged() && !this.applyNeedsRecovery);
    this.applyButton.setAttribute('aria-busy', this.applying ? 'true' : 'false');
    this.applyButton.textContent = this.applying ? 'Applying…' : this.hasApplied && !this.choiceChanged() && !this.applyNeedsRecovery ? 'Applied' : 'Apply carrier';
    this.syncPurchaseLock();
  };
  Controller.prototype.render = function () {
    var self = this, current = this.currentOptions();
    // An invalidated choice must remain reachable even when this size has no
    // carrier mapping: the visitor can explicitly choose No carrier.
    this.root.hidden = !current.length && !this.edit && !this.explicitChoiceRequired;
    this.select.textContent = '';
    function append(value, text, disabled, selected) {
      var option = document.createElement('option');
      option.value = value;
      option.textContent = text;
      option.disabled = disabled;
      option.selected = selected;
      self.select.appendChild(option);
    }
    if (this.explicitChoiceRequired) append('', 'Choose a carrier', true, true);
    append('none', 'No carrier', false, !this.explicitChoiceRequired && this.fitting === 'none');
    current.forEach(function (entry) {
      var label = (entry.fitting === 'us' ? 'US · ' : 'UK/EU · ') + entry.label;
      if (entry.recommended) label += ' · Recommended';
      if (!entry.available) label += ' · Unavailable';
      append(String(entry.id), label, !entry.available, !self.explicitChoiceRequired && self.carrierId === entry.id);
    });
    this.editContext.hidden = !this.edit || (this.edit.valid && !this.editMatches());
    this.renderBusy();
  };
  Controller.prototype.onChange = function (event) {
    var target = event.target;
    if (target !== this.select || target.disabled) return;
    var choice = this.option(target.value);
    if (target.value !== 'none' && (!choice || !choice.available)) return;
    this.choiceRevision += 1;
    this.explicitChoiceRequired = false;
    this.fitting = choice ? choice.fitting : 'none';
    this.carrierId = choice ? choice.id : 0;
    this.rememberChoice(true);
    this.clearChoiceValidation();
    this.say(this.currentIssue());
    this.renderBusy();
  };
  Controller.prototype.onVariant = function (event) {
    var variant = event.detail && event.detail.variant;
    var next = variant && positive(variant.id) ? Number(variant.id) : 0;
    if (this.variantId === next) return;
    this.rememberChoice();
    this.variantId = next;
    this.choiceRevision += 1;
    var chosen = this.option(this.carrierId);
    if (this.explicitChoiceRequired || this.fitting !== 'none' && (!chosen || !chosen.available || chosen.fitting !== this.fitting)) {
      // Keep a compatible current choice. Otherwise restore only a choice that
      // belonged to this variant and is still explicitly offered and available.
      // A recommendation never chooses a replacement on the visitor's behalf.
      var remembered = this.rememberedChoices[next];
      var restored = remembered && this.option(remembered.carrierId);
      var valid = remembered && (remembered.fitting === 'none' && !remembered.carrierId ||
        restored && restored.available && restored.fitting === remembered.fitting);
      this.carrierId = valid && restored ? restored.id : 0;
      this.fitting = valid ? remembered.fitting : 'unresolved';
      this.explicitChoiceRequired = !valid;
    }
    this.say(this.currentIssue() || (this.explicitChoiceRequired ? 'Please choose a carrier for this size, or select No carrier.' : ''));
    // Impulse emits variantChange before updating its native master select.
    // Recheck after that synchronous update, only for this latest local choice.
    var self = this, revision = this.choiceRevision;
    Promise.resolve().then(function () {
      if (!self.destroyed && self.choiceRevision === revision) self.clearChoiceValidation();
    });
    // A different size remains a normal purchase. Apply is available only for
    // the exact original parent variant, without locking the size controls.
    this.render();
  };
  Controller.prototype.clearChoiceValidation = function () {
    var selected = this.form.querySelector('[data-product-select]');
    var variant = this.variants[this.variantId], chosen = this.option(this.carrierId);
    if (this.explicitChoiceRequired || !variant || !variant.available || !selected || Number(selected.value) !== this.variantId ||
        this.fitting !== 'none' && (!chosen || !chosen.available || chosen.fitting !== this.fitting)) return;
    // A corrected local choice may retire its own validation only. Stock,
    // transport and unresolved-purchase notices keep their existing owner.
    var notice = this.form.querySelector('.errors[data-mekhann-carrier-validation="choice"]');
    if (notice) notice.remove();
  };
  Controller.prototype.validateParent = function (cart, expectedVariantId) {
    var grouping = groups(), descriptor = this.edit && this.edit.descriptor;
    var expected = expectedVariantId == null ? this.variantId : Number(expectedVariantId);
    if (!grouping || !descriptor || Number(descriptor.variantId) !== expected || !cart || !Array.isArray(cart.items)) {
      throw error('This fitting link could not be confirmed. Please reopen fitting options from your bag.');
    }
    var parents = grouping.selectionMembers(cart, descriptor);
    if (!parents.length || parents.some(function (item) {
      return Number(item.product_id) !== this.productId || Number(item.variant_id) !== expected || item.parent_relationship || Number(item.quantity) < 1;
    }, this)) throw error('This lampshade selection is no longer in your bag. Please reopen fitting options from your bag.');
    return parents;
  };
  Controller.prototype.loadEdit = function () {
    var self = this, revision = this.choiceRevision, expected = this.editVariantId;
    this.say('Checking the lampshade in your bag…', true);
    if (!this.edit.valid) {
      this.editError = 'This fitting link could not be confirmed. Please reopen fitting options from your bag.';
      this.say(this.editError);
      this.render();
      return;
    }
    readyService().then(function (engine) { return engine.pdpReadCart(); }).then(function (cart) {
      if (self.destroyed) return;
      var parents = self.validateParent(cart, expected), parent = parents[0], grouping = groups();
      var updated = cart._mekhann_carrier_options && cart._mekhann_carrier_options[expected];
      if (Array.isArray(updated) && self.variants[expected]) self.variants[expected].options = options(updated);
      self.edit.descriptor = grouping.selectionDescriptor(parent);
      self.editReady = true;
      self.editError = '';
      self.confirmedCarrierId = service().selectedCarrierVariantId(cart, parent) || 0;
      // Resolving a deep link must not overwrite a choice or size the visitor
      // changed while that read was pending, nor a purchase now in progress.
      if (revision === self.choiceRevision && self.variantId === expected && !purchaseBusy) {
        var existingId = self.confirmedCarrierId;
        var choice = self.option(existingId);
        self.fitting = choice ? choice.fitting : existingId ? 'unresolved' : 'none';
        self.carrierId = choice ? choice.id : 0;
        self.explicitChoiceRequired = Boolean(existingId && (!choice || !choice.available));
        self.say(self.explicitChoiceRequired ? 'Choose an available carrier or No carrier for the lampshade in your bag.' : '');
      }
      self.render();
    }).catch(function (problem) {
      if (self.destroyed) return;
      self.editReady = false;
      self.editError = problem.description || problem.message || 'Fitting options could not be loaded. Please refresh this page.';
      if (self.variantId === expected) self.say(self.editError);
      self.render();
    });
  };
  Controller.prototype.chosenCarrier = function () {
    if (this.explicitChoiceRequired) throw error('Please choose an available carrier, or select No carrier.', 'choice');
    var chosen = this.option(this.carrierId);
    if (this.fitting !== 'none' && (!chosen || !chosen.available || chosen.fitting !== this.fitting)) throw error('Please choose an available carrier, or select No carrier.', 'choice');
    if (this.carrierId && !service()) throw error('Fitting options are still loading. Please try again in a moment.');
    return this.fitting === 'none' ? 0 : this.carrierId;
  };
  Controller.prototype.prepare = function (choices) {
    if (this.destroyed || !Array.isArray(choices) || !choices.length) throw error('Please refresh this page before adding to your bag.');
    if (applyingController) throw error('Please wait for your carrier to finish updating.');
    var selected = this.form.querySelector('[data-product-select]');
    var actualId = selected && Number(selected.value);
    if (!positive(actualId) || actualId !== this.variantId || Number(choices[0].id) !== this.variantId) throw error('Please check your selected lampshade before continuing.');
    var selectedCarrier = this.chosenCarrier();
    var copies = choices.map(function (choice) { return Object.assign({}, choice, { properties: Object.assign({}, choice.properties || {}) }); });
    if (!this.parentGroupId) this.parentGroupId = newGroup();
    copies[0].properties[GROUP_PROPERTY] = this.parentGroupId;
    // Add to Shopping Bag always requests a new purchase, including deep links.
    return { choices: copies, carrierVariantId: selectedCarrier, parentGroupId: this.parentGroupId,
      expectedVariantId: this.variantId, expectedProductId: this.productId, edit: false };
  };
  Controller.prototype.afterAdded = function (result) {
    var intent = result && result.intent;
    if (!intent || intent.edit || !intent.carrierVariantId) return Promise.resolve({ cart: result && result.cart });
    return readyService().then(function (engine) {
      return engine.pdpSetFitting({ parentGroupId: intent.parentGroupId, carrierVariantId: intent.carrierVariantId,
        expectedVariantId: intent.expectedVariantId, expectedProductId: intent.expectedProductId });
    });
  };
  Controller.prototype.applyExisting = function () {
    var self = this, intent;
    try {
      if (this.destroyed || purchaseBusy || applyingController) throw error('Please wait for your shopping bag to finish updating.');
      if (!this.editMatches() || !this.editReady) throw error(this.editError || 'Please reopen fitting options from your shopping bag.');
      var selectedId = this.chosenCarrier();
      if (!this.choiceChanged() && !this.applyNeedsRecovery) return Promise.resolve({ unchanged: true });
      intent = {edit: true, parentDescriptor: this.edit.descriptor, carrierVariantId: selectedId,
        expectedVariantId: this.variantId, expectedProductId: this.productId};
    } catch (problem) { this.say(problem.description || problem.message); return Promise.reject(problem); }
    this.applying = true;
    applyingController = this;
    this.choiceRevision += 1;
    intent.choiceRevision = this.choiceRevision;
    this.applyError = '';
    this.applyNeedsRecovery = false;
    syncControls();
    this.say('');
    return this.update(intent).catch(function (problem) {
      self.applyError = problem.description || problem.message || 'We could not confirm the carrier. Please check your shopping bag.';
      self.applyErrorVariantId = intent.expectedVariantId;
      self.applyNeedsRecovery = true;
      if (self.variantId === intent.expectedVariantId && self.choiceRevision === intent.choiceRevision) self.say(self.applyError);
      throw problem;
    }).finally(function () {
      self.applying = false;
      if (applyingController === self) applyingController = null;
      syncControls();
    });
  };
  Controller.prototype.update = function (intent) {
    var self = this;
    if (!intent || !intent.edit || !this.editReady || applyingController !== this) return Promise.reject(error(this.editError || 'Please reopen fitting options from your bag.'));
    return readyService().then(function (engine) {
      // The engine revalidates parent identity, current allow-list, discount and
      // protected cart contents, and awaits its normal cart:build refresh.
      return engine.pdpSetFitting({ parentDescriptor: intent.parentDescriptor, carrierVariantId: intent.carrierVariantId,
        expectedVariantId: intent.expectedVariantId, expectedProductId: intent.expectedProductId });
    }).then(function (result) {
      if (self.destroyed) return result;
      if (!result || !result.cart) throw error('We could not confirm the carrier. Please check your shopping bag.');
      var parents = self.validateParent(result.cart, intent.expectedVariantId);
      self.edit.descriptor = groups().selectionDescriptor(parents[0]);
      var existingId = service().selectedCarrierVariantId(result.cart, parents[0]) || 0;
      self.confirmedCarrierId = existingId;
      self.hasApplied = !result.warning;
      self.applyNeedsRecovery = false;
      self.applyError = result.warning || '';
      self.applyErrorVariantId = intent.expectedVariantId;
      var ownsVisibleChoice = self.variantId === intent.expectedVariantId && self.choiceRevision === intent.choiceRevision;
      if (ownsVisibleChoice) {
        var choice = self.option(existingId);
        self.fitting = choice ? choice.fitting : existingId ? 'unresolved' : 'none';
        self.carrierId = choice ? choice.id : 0;
        self.explicitChoiceRequired = Boolean(existingId && (!choice || !choice.available));
      }
      self.render();
      if (ownsVisibleChoice) self.say(result.warning || 'Carrier updated in your shopping bag.', !result.warning);
      return result;
    });
  };
  Controller.prototype.setPurchaseBusy = setPurchaseBusy;
  Controller.prototype.settled = function (success, intent) {
    // Failed or ambiguous POSTs retain their group. Only the purchase owner confirms acceptance.
    if (success && (!intent || intent.parentGroupId === this.parentGroupId)) this.parentGroupId = '';
  };
  Controller.prototype.destroy = function () {
    this.destroyed = true;
    this.root.removeEventListener('change', this.boundChange);
    this.applyButton.removeEventListener('click', this.boundApply);
    this.section.removeEventListener('variantChange', this.boundVariant);
    if (this.form.__mekhannPdpCarrier === this) delete this.form.__mekhannPdpCarrier;
    delete this.root.__mekhannCarrierController;
    // An in-flight service keeps the global guard until its promise settles.
  };

  function initialise(root) {
    if (root.__mekhannCarrierController) return root.__mekhannCarrierController;
    var form = document.getElementById(root.dataset.carrierFormId);
    if (!form) return null;
    try { var controller = new Controller(root, form); instances.push(controller); return controller; }
    catch (problem) {
      root.hidden = true;
      form.__mekhannPdpCarrier = { prepare: function () { throw error('Carrier choices could not be loaded. Please refresh this page before adding to your bag.'); } };
      return form.__mekhannPdpCarrier;
    }
  }
  function initWithin(scope) {
    if (scope.matches && scope.matches(ROOT)) initialise(scope);
    Array.prototype.forEach.call(scope.querySelectorAll(ROOT), initialise);
  }
  window.MekhannPdpCarrier = {
    version: 'V2.28.5',
    syncControls: syncControls,
    setPurchaseBusy: setPurchaseBusy,
    isApplying: function () { return Boolean(applyingController); },
    forForm: function (form) {
      if (!form) return null;
      if (form.__mekhannPdpCarrier) return form.__mekhannPdpCarrier;
      var roots = document.querySelectorAll(ROOT);
      for (var i = 0; i < roots.length; i += 1) if (roots[i].dataset.carrierFormId === form.id) return initialise(roots[i]);
      return null;
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initWithin(document); }, { once: true });
  else initWithin(document);
  document.addEventListener('mekhann:native-batch:resolved', function (event) {
    var detail = event.detail || {}, engine = service();
    if (!engine || !detail.intent || !engine.isRenderReceiptCurrent(detail.renderReceipt) ||
        !engine.nativeBatchResolvedTokens || engine.nativeBatchResolvedTokens().indexOf(detail.token) === -1 ||
        !detail.intent.nativeBatch || detail.intent.nativeBatch.token !== detail.token) return;
    instances.forEach(function (controller) {
      if (controller.destroyed) return;
      if (controller.parentGroupId === detail.intent.parentGroupId) controller.settled(true, detail.intent);
      var notice = controller.form.querySelector('.errors[data-mekhann-native-error-token]');
      if (notice && notice.getAttribute('data-mekhann-native-error-token') === detail.token) notice.remove();
    });
  });
  document.addEventListener('shopify:section:load', function (event) { initWithin(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    instances = instances.filter(function (controller) {
      if (!event.target.contains(controller.root)) return true;
      controller.destroy();
      return false;
    });
  });
})();
